import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap } from 'rxjs/operators';
import { OrganizationService } from '../organization.service';
import { fetchCurrentOrganization, getOrganizationById, setCurrentOrganization } from './organization.actions';
import { PersonsService } from '../../core/services/persons/persons.service';

@Injectable()
export class OrganizationEffects {
  actions = inject(Actions);
  organizationService = inject(OrganizationService);
  personsService = inject(PersonsService);

  fetchCurrentOrganization = createEffect(() => {
    return this.actions.pipe(
      ofType(fetchCurrentOrganization),
      mergeMap(() =>
        this.personsService.fetchCurrentPerson().pipe(
          mergeMap(user => [getOrganizationById({ id: user.organization_id })]),
          catchError(() => []),
        ),
      ),
    );
  });

  getOrganizationById = createEffect(() => {
    return this.actions.pipe(
      ofType(getOrganizationById),
      mergeMap(({ id }) =>
        this.organizationService.getCurrentOrganization(id).pipe(
          mergeMap(organization => [setCurrentOrganization({ organization })]),
          catchError(() => []),
        ),
      ),
    );
  });
}
